import { ICreateInspecaoObraOcorrenciaUseCase } from "../../../presentation/useCases/create/create_inspecao_obra_ocorrencia_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateInspecaoObraOcorrenciaUseCase
 */

export class CreateInspecaoObraOcorrenciaUseCase implements ICreateInspecaoObraOcorrenciaUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createInspecaoObraOcorrencia(
    idObra: number,
    idInspecaoObra: number,
    idItemInspecao: number | null,
    inspecao: number | null,
    descricao: string,
    dataDescricao: Date | null,
    tratativa: string | null,
    dataTratativa: Date | null,
  ): Promise<void> {
    await this.repository.createInspecaoObraOcorrencia(
      idObra,
      idInspecaoObra,
      idItemInspecao,
      inspecao,
      descricao,
      dataDescricao,
      tratativa,
      dataTratativa,
    );
  }
}
